/**
 * The single source of truth for the Active Organization id (ADR-026
 * Addendum, Decision AO-1). Distinct from the access token
 * (`lib/api/auth-token.ts`): its own `sessionStorage` key, never
 * `localStorage`, never inferred independently inside a feature module.
 * A dependency-free leaf module, imported by both the HTTP client (to
 * attach `X-Organization-Id`) and `features/organization`'s provider, so
 * neither imports the other.
 */

const STORAGE_KEY = 'mahfuz.activeOrganizationId';

export function getActiveOrganizationId(): string | null {
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function setActiveOrganizationId(organizationId: string): void {
  sessionStorage.setItem(STORAGE_KEY, organizationId);
}

export function clearActiveOrganizationId(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}
